import { useMutation } from "@apollo/client";
import {
  DELETE_SEASON,
  GET_SEASONS_BY_COMPETITION_ID,
  SEASONS_WITH_PERMISSION,
} from "../../GraphQL/Season";
import useNotification from "../../hooks/useNotification.js";
import ConfirmDeleteDialog from "../UI/ConfirmDeleteDialog.js";

const DeleteSeasonDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [deleteSeason, { loading, error }] = useMutation(DELETE_SEASON, {
    variables: { id: props.season.id },
    refetchQueries: [GET_SEASONS_BY_COMPETITION_ID, SEASONS_WITH_PERMISSION],
    onCompleted: () => {
      notifySuccess("Season deleted.");
      props.setOpen(false);
    },
  });

  return (
    <ConfirmDeleteDialog
      open={props.open}
      setOpen={props.setOpen}
      entityName={props.season.name}
      onConfirm={deleteSeason}
      loading={loading}
      error={error}
      confirmTestId="saveDeleteSeasonDialogButton"
      cancelTestId="closeDeleteSeasonDialogButton"
    />
  );
};

export default DeleteSeasonDialog;
